module.exports = __webpack_public_path__ + "img/oneBlue.4c1d62d0.jpg";